import { useMemo, useState } from "react";
import { useAtom } from "jotai";
import { toast } from "react-toastify";
import { questionsConfigAtom } from "../formConfigAuto";
import { buildFormStateFromLeadData } from "../leadAutoDataFormatter";
import { getMissingFields, isCompletionKnown } from "../leadAutoCompletion";
import { finalizeLeadAuto } from "../../../../../services/graal-api/leadAutoService";
import useLeadAutoItem from "../useLeadAutoItem";

const CONFIRM_MESSAGE =
  "Finaliser cette demande ?\n\nElle apparaîtra dans les demandes en cours de l'espace client. Aucun email ne sera envoyé.";

const useLeadAutoFinalize = (leadData) => {
  const [questionsConfig] = useAtom(questionsConfigAtom);
  const { actions: leadActions } = useLeadAutoItem();

  const [isFinalizing, setIsFinalizing] = useState(false);

  const formState = useMemo(
    () => buildFormStateFromLeadData(leadData, questionsConfig),
    [leadData, questionsConfig],
  );

  const missingFields = useMemo(
    () => getMissingFields(formState, questionsConfig),
    [formState, questionsConfig],
  );

  const isFinalized = !!leadData?.isFinalized;
  const canFinalize =
    !isFinalized &&
    !isFinalizing &&
    isCompletionKnown(formState, questionsConfig) &&
    missingFields.length === 0;

  const finalize = async () => {
    if (!canFinalize) return;
    if (!window.confirm(CONFIRM_MESSAGE)) return;

    setIsFinalizing(true);

    try {
      await finalizeLeadAuto(leadData.id);
      toast.success("La demande a été finalisée");
      await leadActions.refreshLead();
    } catch (err) {
      console.error("Erreur lors de la finalisation du lead:", err);
      toast.error(
        err.response?.data?.message ||
          "Erreur lors de la finalisation de la demande.",
      );
    } finally {
      setIsFinalizing(false);
    }
  };

  return {
    isFinalized,
    isFinalizing,
    canFinalize,
    missingFields,
    finalize,
  };
};

export default useLeadAutoFinalize;
